import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: auto;
`;

const SelectBox = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  color: #000;
  cursor: pointer;
  font-size: 18px;
  user-select: none;
  background-color: #fff;
`;

const DropdownList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
  background-color: #fff;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
`;

const DropdownItem = styled.li`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const SelectRegion = ({ setType, regions, regionL }) => {  
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (reg) => {
    setSelected(reg.region_name);
    setType?.(reg.region_id);
    setOpen(false);
  };

  useEffect(() => {
    setSelected(regionL || '');
  }, [regionL])

  return (
    <Container ref={containerRef}>
      <SelectBox onClick={() => setOpen((prev) => !prev)}>
        {selected || 'Region'}
      </SelectBox>
      {open && (
        <DropdownList>
          {regions?.map((region) => (
            <DropdownItem
              key={region.region_id}
              onClick={() => handleSelect(region)}
            >
              {region.region_name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </Container>
  );
};

export default SelectRegion;
